export const REQUEST_STARTED = 'http-request';
export const REQUEST_COMPLETED = 'http-completed';
export const REQUEST_ERRORED = 'http-errored';
export const REQUEST_PROCESSED = 'http-processed';
export const REQUEST_FLUSH = 'http-flush';